export default __webpack_public_path__ + "static/media/ExpansaoRemocao.9a8982fe.gif";